export default __webpack_public_path__ + "static/media/bg-gradient-parteneri.87a96c40.png";